var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 pb-2 rounded-lg",attrs:{"width":"100%","flat":"","outlined":"","rounded":"","color":"#F1F4FB","height":"100%"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }